import type { SnapshotPayload } from '~/lib/api/types'
import styles from './summary-bar.module.scss'

type Props = { snapshot: SnapshotPayload; isFetching: boolean }

export function SummaryBar({ snapshot, isFetching }: Props) {
  const { working, out, missing } = snapshot.totals
  const total = working + out + missing

  return (
    <div
      className={`${styles.bar} ${isFetching ? styles.refreshing : ''}`}
      aria-live="polite"
    >
      <Sentence
        working={working}
        total={total}
        out={out}
        missing={missing}
        isWeekend={snapshot.is_weekend}
      />
    </div>
  )
}

function Sentence({
  working,
  total,
  out,
  missing,
  isWeekend,
}: {
  working: number
  total: number
  out: number
  missing: number
  isWeekend: boolean
}) {
  if (total === 0) {
    return <span className={styles.text}>No active engineers.</span>
  }

  if (isWeekend && working === 0) {
    return (
      <span className={styles.text}>
        It&apos;s the weekend — nobody&apos;s expected to check in.
      </span>
    )
  }

  if (missing === 0 && out === 0 && working === total) {
    return <span className={styles.text}>Everyone&apos;s checked in.</span>
  }

  const parts: string[] = [`${working} of ${total} checked in.`]
  if (out > 0) parts.push(`${out} out today.`)
  if (missing > 0) parts.push(`${missing} missing.`)
  if (isWeekend) parts.push('(weekend)')

  return <span className={styles.text}>{parts.join(' ')}</span>
}
